/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Tooltips_VarianceInputs */

const id_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selisih antara posisi saat ini dan posisi sebelumnya. Biasanya berubah setiap hari.`)
};

const ms_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbezaan antara kedudukan semasa dan kedudukan sebelumnya. Biasanya berubah setiap hari.`)
};

const da_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forskellen mellem den nuværende position og den forrige position. Ændrer sig normalt hver dag.`)
};

const de_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Unterschied zwischen der aktuellen und der vorherigen Position. Ändert sich normalerweise täglich.`)
};

const en_us2_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The difference between the current position and the previous position. Usually changes every day.`)
};

const es_es2_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La diferencia entre la posición actual y la posición anterior. Suele cambiar cada día.`)
};

const es_mx2_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La diferencia entre la posición actual y la posición anterior. Generalmente cambia cada día.`)
};

const fil_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pagkakaiba sa pagitan ng kasalukuyang posisyon at nakaraang posisyon. Karaniwang nagbabago araw-araw.`)
};

const fr_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La différence entre la position actuelle et la position précédente. Change généralement chaque jour.`)
};

const it_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La differenza tra la posizione attuale e quella precedente. Di solito cambia ogni giorno.`)
};

const hu_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A különbség az aktuális és az előző pozíció között. Általában naponta változik.`)
};

const nl_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verschil tussen de huidige positie en de vorige positie. Verandert meestal elke dag.`)
};

const no_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forskjellen mellom nåværende posisjon og forrige posisjon. Endres vanligvis hver dag.`)
};

const pl_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Różnica między obecną a poprzednią pozycją. Zwykle zmienia się codziennie.`)
};

const pt_br2_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diferença entre a posição atual e a posição anterior. Geralmente muda todos os dias.`)
};

const pt_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diferença entre a posição atual e a posição anterior. Geralmente muda todos os dias.`)
};

const ro_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferența dintre poziția curentă și poziția anterioară. De obicei se schimbă zilnic.`)
};

const fi_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ero nykyisen ja edellisen sijoituksen välillä. Yleensä muuttuu päivittäin.`)
};

const sv_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillnaden mellan nuvarande position och föregående position. Ändras vanligtvis varje dag.`)
};

const vi_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự khác biệt giữa vị trí hiện tại và vị trí trước đó. Thường thay đổi mỗi ngày.`)
};

const tr_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut pozisyon ile önceki pozisyon arasındaki fark. Genellikle her gün değişir.`)
};

const cs_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozdíl mezi aktuální pozicí a předchozí pozicí. Obvykle se mění každý den.`)
};

const bg_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разликата между текущата позиция и предишната позиция. Обикновено се променя всеки ден.`)
};

const ru_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разница между текущей и предыдущей позицией. Обычно меняется каждый день.`)
};

const uk_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Різниця між поточною та попередньою позицією. Зазвичай змінюється щодня.`)
};

const ar_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق بين المركز الحالي والمركز السابق. عادةً ما يتغير يوميًا.`)
};

const hi_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान स्थान और पिछले स्थान के बीच का अंतर। आमतौर पर हर दिन बदलता है।`)
};

const th_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความแตกต่างระหว่างตำแหน่งปัจจุบันและตำแหน่งก่อนหน้า โดยปกติจะเปลี่ยนทุกวัน`)
};

const ja_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の順位と前回の順位の差。通常は毎日変わります。`)
};

const zh_cn2_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前排名与上一排名的差值。通常每天更新一次。`)
};

const zh_hant1_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前排名與上一排名的差值。通常每天更新一次。`)
};

const ko_collections_tooltips_variance = /** @type {(inputs: Collections_Tooltips_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 순위와 이전 순위의 차이입니다. 보통 매일 변경됩니다.`)
};

/**
* | output |
* | --- |
* | "The difference between the current position and the previous position. Usually changes every day." |
*
* @param {Collections_Tooltips_VarianceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_tooltips_variance = /** @type {((inputs?: Collections_Tooltips_VarianceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Tooltips_VarianceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_tooltips_variance(inputs)
	if (locale === "ms") return ms_collections_tooltips_variance(inputs)
	if (locale === "da") return da_collections_tooltips_variance(inputs)
	if (locale === "de") return de_collections_tooltips_variance(inputs)
	if (locale === "en-US") return en_us2_collections_tooltips_variance(inputs)
	if (locale === "es-ES") return es_es2_collections_tooltips_variance(inputs)
	if (locale === "es-MX") return es_mx2_collections_tooltips_variance(inputs)
	if (locale === "fil") return fil_collections_tooltips_variance(inputs)
	if (locale === "fr") return fr_collections_tooltips_variance(inputs)
	if (locale === "it") return it_collections_tooltips_variance(inputs)
	if (locale === "hu") return hu_collections_tooltips_variance(inputs)
	if (locale === "nl") return nl_collections_tooltips_variance(inputs)
	if (locale === "no") return no_collections_tooltips_variance(inputs)
	if (locale === "pl") return pl_collections_tooltips_variance(inputs)
	if (locale === "pt-BR") return pt_br2_collections_tooltips_variance(inputs)
	if (locale === "pt") return pt_collections_tooltips_variance(inputs)
	if (locale === "ro") return ro_collections_tooltips_variance(inputs)
	if (locale === "fi") return fi_collections_tooltips_variance(inputs)
	if (locale === "sv") return sv_collections_tooltips_variance(inputs)
	if (locale === "vi") return vi_collections_tooltips_variance(inputs)
	if (locale === "tr") return tr_collections_tooltips_variance(inputs)
	if (locale === "cs") return cs_collections_tooltips_variance(inputs)
	if (locale === "bg") return bg_collections_tooltips_variance(inputs)
	if (locale === "ru") return ru_collections_tooltips_variance(inputs)
	if (locale === "uk") return uk_collections_tooltips_variance(inputs)
	if (locale === "ar") return ar_collections_tooltips_variance(inputs)
	if (locale === "hi") return hi_collections_tooltips_variance(inputs)
	if (locale === "th") return th_collections_tooltips_variance(inputs)
	if (locale === "ja") return ja_collections_tooltips_variance(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_tooltips_variance(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_tooltips_variance(inputs)
	return ko_collections_tooltips_variance(inputs)
});
export { collections_tooltips_variance as "collections.tooltips.variance" }